export default "__VITE_ASSET__PG5FaMgF__"